import script from "./ReasonItem.vue?vue&type=script&lang=js"
export * from "./ReasonItem.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__